<template>
  <div class="header">
    <div class="header-body">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="header-pretitle">Take Action</h6>
          <h1 class="header-title">Create a message</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateMessageHeader'
}
</script>

<style scoped lang="scss"></style>
